import { atom, useAtomValue, useSetAtom } from 'jotai';

/** 搜索的关键词 */
export const searchMsgWord = atom<string>('');

export const useSearchMsgWord = () => {
  return useAtomValue(searchMsgWord);
};

export const useSetSearchMsgWord = () => {
  return useSetAtom(searchMsgWord);
};
